<template>
  <div>
    <h2 class="title-1 col">Статистикууд</h2>
    <div class="stat-tabs mt-4">
      <div class="d-flex">
        <div
          :class="[{ 'tab--selected' : selectedTab === 'user access'}, 'nav-link tab']"
          @click="selectedTab = 'user access'"
        >Хандалтын статистик</div>
        <div
          :class="[{ 'tab--selected' : selectedTab === 'users info'}, 'nav-link tab']"
          @click="selectedTab = 'users info'"
        >Хэрэглэгчийн статистик</div>
        <div
          :class="[{ 'tab--selected' : selectedTab === 'uri access'}, 'nav-link tab']"
          @click="selectedTab = 'uri access'"
        >Контентийн статистик</div>
        <div
          :class="[{ 'tab--selected' : selectedTab === 'banner stat'}, 'nav-link tab']"
          @click="selectedTab = 'banner stat'"
        >Баннер статистик</div>
      </div>
      <br />
      <!-- user access tab -->
      <div v-if="selectedTab === 'user access' && accessStat != null">
        <user-access :accessStat="accessStat" :start="accessStatStart" :end="accessStatEnd" />
      </div>
      <!-- users info tab -->
      <div v-else-if="selectedTab === 'users info'">
        <user-statistic :userStat="userStat" />
      </div>
      <!-- uri access tab -->
      <div v-else-if="selectedTab === 'uri access' && uriStat != null">
        <uri-access :uriStat="uriStat" :start="uriStatStart" :end="uriStatEnd" />
      </div>
      <!-- banner statistic tab -->
      <div v-else-if="selectedTab === 'banner stat' && bannerStat != null">
        <banner-statistic :bannerStat="bannerStat" :start="bannerStatStart" :end="bannerStatEnd" />
      </div>
    </div>
  </div>
</template>

<style>
.stat-tabs {
  background-color: white;
  padding: 10px;
}

.stat-box {
  width: 100%;
  height: 300px;
}

.stat-table {
  width: 100%;
}

.progress-container {
  width: 50%;
}

.progress {
  height: 10px;
  margin-top: 6px;
}
</style>

<script>
import UserAccess from "@/components/statistic/UserAccess";
import UserStatistic from "@/components/statistic/UserStatistic";
import UriAccess from "@/components/statistic/UriAccess";
import BannerStatistic from "@/components/statistic/BannerStatistic";
import StatService from "@/services/StatService";

export default {
  name: "Statistics",

  components: { UserAccess, UriAccess, UserStatistic, BannerStatistic },

  created() {
    this.getAccessStats(null, null);
    this.getUserStats();
    this.getUriStats(null, null);
    this.getBannerStats(null, null);
  },

  data() {
    return {
      selectedTab: "user access",

      accessStat: null,
      accessStatStart: null,
      accessStatEnd: null,

      userStat: null,

      uriStat: null,
      uriStatStart: null,
      uriStatEnd: null,

      bannerStat: null,
      bannerStatStart: null,
      bannerStatEnd: null
    };
  },

  methods: {
    getAccessStats(start, end) {
      let data = JSON.parse("{}");
      if (start != null && end != null) {
        if (this.accessStatStart == start && this.accessStatEnd == end) return;
        data.start = start;
        data.end = end;
      }
      this.$store.dispatch("setLoading", true);
      StatService.getAccessStat(data).then(response => {
        if (response.status == 200 && response.data.success == true) {
          this.accessStatStart = response.data.payload.startDate;
          this.accessStatEnd = response.data.payload.endDate;
          this.accessStat = response.data.payload;
          this.$store.dispatch("setLoading", false);
        }
      });
    },

    getUserStats() {
      this.$store.dispatch("setLoading", true);
      StatService.getUserStat().then(response => {
        if (response.status == 200 && response.data.success == true) {
          this.userStat = response.data.payload;
          this.$store.dispatch("setLoading", false);
        }
      });
    },

    getUriStats(start, end) {
      let data = JSON.parse("{}");
      if (start != null && end != null) {
        if (this.uriStatStart == start && this.uriStatEnd == end) return;
        data.start = start;
        data.end = end;
      }
      this.$store.dispatch("setLoading", true);
      StatService.getUriStat(data).then(response => {
        if (response.status == 200 && response.data.success == true) {
          this.uriStatStart = response.data.payload.startDate;
          this.uriStatEnd = response.data.payload.endDate;
          this.uriStat = response.data.payload;
          this.$store.dispatch("setLoading", false);
        }
      });
    },

    getBannerStats(start, end) {
      let data = JSON.parse("{}");
      if (start != null && end != null) {
        if (this.bannerStatStart == start && this.bannerStatEnd == end) return;
        data.start = start;
        data.end = end;
      }
      this.$store.dispatch("setLoading", true);
      StatService.getBannerStat(data).then(response => {
        if (response.status == 200 && response.data.success == true) {
          this.bannerStatStart = response.data.payload.startDate;
          this.bannerStatEnd = response.data.payload.endDate;
          this.bannerStat = response.data.payload;
          this.$store.dispatch("setLoading", false);
        }
      });
    },

    onDownloadExcel(stat, start, end) {
      let data = JSON.parse("{}");
      if (start != null && end != null) {
        data.start = start;
        data.end = end;
      }
      this.$store.dispatch("setLoading", true);
      StatService.downloadStat({ responseType: "blob" }, stat, data).then(
        response => {
          this.$store.dispatch("setLoading", false);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName =
            stat == "user_stat_excel"
              ? stat + "_" + new Date().toISOString().split("T")[0] + ".xls"
              : stat + "_" + start + "_" + end + ".xls";
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      );
    }
  }
};
</script>